import { render, staticRenderFns } from "./ActionLabel.vue?vue&type=template&id=4eb7ecf5&scoped=true"
import script from "./ActionLabel.vue?vue&type=script&lang=js"
export * from "./ActionLabel.vue?vue&type=script&lang=js"
import style0 from "./ActionLabel.vue?vue&type=style&index=0&id=4eb7ecf5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb7ecf5",
  null
  
)

export default component.exports